import axios from 'axios';
import { setSession } from 'src/utils/jwt';

const defaultOptions = {
  baseURL: process.env.REACT_APP_CMS_BASE_URL,
  headers: {
    'Access-Control-Allow-Origin': '*',
    // 'Content-Type': 'application/json',
  },
};

const CMSClient = axios.create(defaultOptions);

CMSClient.interceptors.response.use((response) => response,
  (error) => {
    const originalRequest = error.config;
    if (error.response.status === 401 && !originalRequest.retry) {
      originalRequest.retry = true;
      const loginData = new URLSearchParams({aa:'a'});
      loginData.append('grant_type', 'refresh_token');
      loginData.append('scope', 'offline_access openid profile');
      loginData.append('client_id', process.env.REACT_APP_CLIENT_ID,);
      loginData.append('client_secret', process.env.REACT_APP_CLIENT_SECRET);
      loginData.append('refresh_token', localStorage.getItem('refreshToken'));
      return CMSClient.post(
        '/connect/token',
        loginData,
        { headers: {
          'Content-Type': 'application/x-www-form-urlencoded',
        } }
      ).then((res: any) => {
        if (res.status === 201) {
          // eslint-disable-next-line @typescript-eslint/naming-convention
          const { access_token, refresh_token } = res.data;
          setSession(access_token, refresh_token);

          // 3) return originalRequest object with Axios.
          return CMSClient(originalRequest);
        }
        return res;
      }).catch((err: any) => {
        setSession(null);
        window.location.replace('/');
        return Promise.reject(err);
      });
    }
    // return Error object with Promise
    return Promise.reject(error);
  });

  CMSClient.interceptors.response.use(
  (response) => response,
  (error) => {
    console.log('error log', error);
    return Promise.reject(
      (error.response && error.response.data) || {
        message: 'error connecting to ids',
      },
    );
  }
);

export default CMSClient;
